export default __webpack_public_path__ + "static/media/Group-3.626e02b4.png";